import { useQuery } from 'react-query'

import { Tax } from '@webapp/platform/finance/entities/Tax'
import { taxRepository } from '../../data-access/repositories/TaxRepository'

export const useTaxSelect = ({ defaultTaxId }: { defaultTaxId?: number }) => {
  const { data, isFetching } = useQuery({
    queryKey: ['selects', 'taxes'],
    queryFn: () => {
      return taxRepository.getTaxes({ pageSize: 999 })
    },
    cacheTime: Infinity,
  })

  return {
    data: {
      defaultValue: data?.data.find((t) => t.id === defaultTaxId) || null,
      taxes: data?.data.map((t) => new Tax(t)) || [],
    },
    states: {
      isFetching,
    },
  }
}
